module.exports = function(media) {
	'use strict'
	media.directive('mediaLibraryDir',mediaLibraryDir);
	mediaLibraryDir.$inject=[];
	function mediaLibraryDir() {
		return {
			restrict: 'E',
			template: require('./partial/library.html'),
			controller:'libraryController',
			controllerAs:'vml',
			link: function(scope, element, attrs, ctrl) {
				
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/library/js/directive/libraryDirective.js
// module id = 515
// module chunks = 0